import useRegistration from './useRegistration';

export default useRegistration;
